import { Calendar } from 'lucide-react'
import { useLocation } from 'react-router-dom'

import { useTranslation } from '@/core/i18n/useTranslation'

import Icon from '@shared/components/atoms/Icon'

import MobileDrawerMenuUI from './MobileDrawerMenuUI'

export const shouldRenderMobileDrawerMenu = (pathname: string) => {
	return !(
		pathname === '/zones/create' ||
		/^\/campaigns\/create(\/upload)?$/.test(pathname) ||
		/^\/campaigns\/\d+\/edit(\/upload)?$/.test(pathname) ||
		pathname.startsWith('/campaigns/create-ai')
	)
}

const MobileDrawerMenu = () => {
	const { t } = useTranslation('common')
	const location = useLocation()

	if (!shouldRenderMobileDrawerMenu(location.pathname)) {
		return null
	}

	const items = [
		{
			icon: <Icon name="geo-alt" />,
			label: t('navigation.zones'),
			to: '/zones',
		},
		{
			icon: <Icon name="music-note-beamed" />,
			label: t('navigation.music'),
			to: '/music',
		},
		{
			icon: (
				<span className="[&>svg]:!w-6 [&>svg]:!h-6 2xl:[&>svg]:!w-7 2xl:[&>svg]:!h-7">
					<Calendar
						strokeWidth={1.5}
						className="[&_*]:!stroke-[currentColor]"
					/>
				</span>
			),
			label: t('navigation.schedule'),
			to: '/schedules',
		},
		{
			icon: <Icon name="megaphone" />,
			label: t('navigation.campaigns'),
			to: '/campaigns',
		},
	]

	return <MobileDrawerMenuUI items={items} />
}

export default MobileDrawerMenu
